// extracted by mini-css-extract-plugin
export default {"idea":"KltjU4","overlay":"I9h20Y"};